import { useEffect, useState } from "react";
import useGeneral from "../../../components/hooks/useGeneral";
import { useTheme } from "../../../components/hooks/useTheme";
import Select from "react-select";
import CustomFormatDatePicker from "../../../components/common/CustomFormatDatePicker";
import { validateMin } from "../../../utils/validateMin";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axois from "../../../configs/axois";
import baseURL from "../../../configs/api";
import axios from "axios";
import PleaseWaitPopup from "../../PleaseWaitPopup";
import AvailabilityInput from "../../../components/AvailabilityInput";
import colorConfigs from "../../../configs/colorConfigs";
import useAuth from "../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";


export const AddVehicle = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { themeStyles } = useTheme();
  const { dateFormat }: any = useGeneral();
  const navigate = useNavigate();
  const [vin, setVin] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [vehicleKey, setVehicleKey] = useState<string>("");
  const [vehicleBarcode, setVehicleBarcode] = useState<string>("");
  const [licensePlate, setLicensePlate] = useState<string>("");
  const [vehicleMarkeId, setVehicleMarkeId] = useState("");
  const [vehicleModel, setVehicleModel] = useState<any>();
  const [vehicleEngine, setVehicleEngine] = useState<any>();
  const [vehicleClassId, setVehicleClassId] = useState(null);
  const [vehiclSecondaryClassId, setVehiclSecondaryClassId] = useState(null);
  const [vehicleTypeId, setVehicleTypeId] = useState<string>("");
  const [availableDate, setAvailableDate] = useState<string>("");
  const [availableUntil, setAvailableUtil] = useState<string>("");
  const [vehicleColor, setColor] = useState<string>("");
  const [odometer, setOdometer] = useState<number>(0);
  const [statusId, setStatusId] = useState<string>("");
  const [fuelLevel, setFuelLevel] = useState<string>("");
  const [currentLocations, setCurrentLocations] = useState<any[]>([]);
  const [currentLocationId, setCurrentLocationId] = useState<string>("");
  const [vehicleYear, setVehicleYear] = useState<string>("");
  const [lastMaintenanceOdoMeter, setLastMaintenanceOdoMeter] =
    useState<number>(0);
  const [lastMaintenanceDate, setLastMaintenanceDate] = useState<string>("");
  const [lastWheelRotationOdoMeter, setLastWheelRotationOdoMeter] =
    useState<number>(0);
  const [lastWheelRotationDate, setLastWheelRotationDate] =
    useState<string>("");
  const [lastWheelAlignmentOdoMeter, setLastWheelAlignmentOdoMeter] =
    useState<number>(0);
  const [lastWheelAlignmentDate, setLastWheelAlignmentDate] =
    useState<string>("");

  const [vehicleClassOptions, setVehicleClassOptions] = useState<any[]>([]);
  const [vehicleTypeOptions, setVehicleTypeOptions] = useState<any[]>([]);
  const [vehicleMakeOptions, setVehicleMakeOptions] = useState<any[]>([]);
  const [vehicleModeOptions, setVehicleModeOptions] = useState<any[]>([]);
  const [availableVehicleModeOptions, setAvailableVehicleModeOptions] =
    useState<any[]>([]);
  const [vehicleEngineOptions, setVehicleEngineOptions] = useState<any[]>([]);
  const [availableVehicleEngineOptions, setAvailableVehicleEngineOptions] =
    useState<any[]>([]);
  const [vehicleStatus, setVehicleStatus] = useState<any[]>([]);
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [availability, setAvailability] = useState({
    vin: true,
    vehicleKey: true,
    vehicleBarcode: true,
    licensePlate: true,
  });

  const handleAvailabilityChange = (field: keyof typeof availability) => (isAvailable: boolean) => {
    setAvailability((prev) => ({ ...prev, [field]: isAvailable }));
  };

  const isFormValid = availability.vin && availability.vehicleKey && availability.vehicleBarcode && availability.licensePlate;

  const validateVin = (vin: string): string | null => {
    const vinPattern = /^[A-HJ-NPR-Z0-9]+$/i;
    if (!vinPattern.test(vin)) {
      return "❌ VIN must contain only letters and numbers (excluding I, O, Q)";
    }
    return null;
  };

  useEffect(() => {
    axois
      .get(`${baseURL}location`, {
        headers: {
          'X-Tenant-ID': tenantId,
        },
      })
      .then((response) => {
        setCurrentLocations(() =>
          response.data.map((item: any) => {
            return { value: item.id, label: item.locationName };
          })
        );

        setCurrentLocationId(response.data[0]?.id);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axois
      .get(`${baseURL}vehicleClass`, {
        headers: {
          'X-Tenant-ID': tenantId,
        },
      })
      .then((response) => {
        setVehicleClassOptions(() =>
          response.data.map((item: any) => {
            return { value: item.id, label: item.name };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axois
      .get(`${baseURL}vehicleType/GetVehicleTypesWithActiveStatus/true`, {
        headers: {
          'X-Tenant-ID': tenantId,

        },
      })
      .then((response) => {
        setVehicleTypeOptions(() =>
          response?.data?.map((item: any) => {
            return { value: item.id, label: item.name };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {
        setVehicleTypeOptions([]);
        handleTenantError(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axois
      .get(`${baseURL}vehicleMake`, {
        headers: {
          'X-Tenant-ID': tenantId

        },
      })
      .then((response) => {
        setVehicleMakeOptions(() =>
          response.data.map((item: any) => {
            return { value: item.id, label: item.makeName };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    axois
      .get(`${baseURL}vehicleModel`, {
        headers: {
          'X-Tenant-ID': tenantId
        },
      })
      .then((response) => {
        setVehicleModeOptions(() =>
          response.data.map((item: any) => {
            return {
              value: item.id,
              label: item.modelName,
              vehicleMakeId: item.vehicleMakeId,
            };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (vehicleModeOptions && vehicleMarkeId) {
      setAvailableVehicleModeOptions(() =>
        vehicleModeOptions.filter(
          (item: any) => item.vehicleMakeId === vehicleMarkeId
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleMarkeId]);

  useEffect(() => {
    setVehicleModel(() => availableVehicleModeOptions[0]);
  }, [availableVehicleModeOptions]);

  useEffect(() => {
    axois
      .get(`${baseURL}vehicleEngine`, {
        headers: {
          'X-Tenant-ID': tenantId
        },
      })
      .then((response) => {
        setVehicleEngineOptions(() =>
          response.data.map((item: any) => {
            return {
              value: item.id,
              label: item.engineName,
              vehicleModelId: item.vehicleModelId,
            };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (vehicleEngineOptions && vehicleModeOptions) {
      setAvailableVehicleEngineOptions(() =>
        vehicleEngineOptions.filter(
          (item: any) => item.vehicleModelId === vehicleModel?.value
        )
      );
    }
  }, [vehicleEngineOptions, vehicleModeOptions, vehicleModel]);

  useEffect(() => {
    setVehicleEngine(() => availableVehicleEngineOptions[0]);
  }, [availableVehicleEngineOptions]);

  useEffect(() => {
    axois
      .get(`${baseURL}vehicleStatus`, {
        headers: {
          'X-Tenant-ID': tenantId
        },
      })
      .then((response) => {
        setVehicleStatus(() =>
          response.data
            .map((item: any) => {
              return {
                value: item.id,
                label: item.statusName,
                attributeName: item.attributeName,
              };
            })
            .filter((value: any) => value.attributeName === "Vehicle")
        );

        setStatusId(() => response.data[0].id);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!isFormValid) {
      return;
    }

    setPleaseWaitPopup(true);
    await axios
      .post(
        `${baseURL}vehicles?userId=${auth?.id}`,
        JSON.stringify({
          name,
          vin,
          vehicleKey,
          vehicleBarcode,
          licensePlate,
          vehicleMarkeId,
          vehicleModelId: vehicleModel?.value,
          vehicleEngineId: vehicleEngine?.value,
          vehicleClassId,
          vehiclSecondaryClassId,
          vehicleTypeId,
          odometer,
          fuelLevel,
          statusId,
          vehicleColor,
          availableDate: `${availableDate}T00:00:00`,
          availableUntil: `${availableUntil}T00:00:00`,
          currentLocationId,
          vehicleYear,
          lastMaintenanceOdoMeter,
          lastMaintenanceDate: lastMaintenanceDate
            ? `${lastMaintenanceDate}T00:00:00`
            : lastMaintenanceDate,
          lastWheelRotationOdoMeter,
          lastWheelRotationDate: lastWheelRotationDate
            ? `${lastWheelRotationDate}T00:00:00`
            : lastWheelRotationDate,
          lastWheelAlignmentOdoMeter,
          lastWheelAlignmentDate: lastWheelAlignmentDate
            ? `${lastWheelAlignmentDate}T00:00:00`
            : lastWheelAlignmentDate,
        }),
        {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
          },
          withCredentials: true,
        }
      )
      .then(() => {
        setPleaseWaitPopup(false);
        navigate(-1);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  };

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>

              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Vehicle</h2>
                </div>
              </div>
              <div className="flex">
                <div className="mt-2 p-2 w-[50%]">
                  <form
                    onSubmit={(e) => handleSubmit(e)}
                  >
                    <div className="w-full px-2">
                      <div className="grid grid-cols-2 gap-6">
                        <AvailabilityInput
                          label="VIN"
                          name="vin"
                          value={vin}
                          onChange={setVin}
                          baseURL={baseURL}
                          validate={validateVin}
                          onAvailabilityChange={handleAvailabilityChange("vin")}
                        />

                        <AvailabilityInput
                          label="Vehicle Key"
                          name="vehicleKey"
                          value={vehicleKey}
                          onChange={(value) => {
                            setVehicleKey(value);
                          }}
                          baseURL={baseURL} onAvailabilityChange={handleAvailabilityChange("vehicleKey")}
                        />
                      </div>

                      <div className="grid grid-cols-2 gap-6 mt-[16px]">
                        <AvailabilityInput
                          label="License Plate"
                          name="licensePlate"
                          value={licensePlate}
                          onChange={setLicensePlate}
                          baseURL={baseURL}
                          onAvailabilityChange={handleAvailabilityChange("licensePlate")}
                        />

                        <AvailabilityInput
                          label="Vehicle Barcode"
                          name="vehicleBarcode"
                          value={vehicleBarcode}
                          onChange={setVehicleBarcode}
                          baseURL={baseURL}
                          onAvailabilityChange={handleAvailabilityChange("vehicleBarcode")}
                        />
                      </div>

                      <div className="grid grid-cols-2 gap-6 mt-[16px]">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Name</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-6 mt-[16px]">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Make</label>
                            <Select
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  backgroundColor: "transparent",
                                  color: themeStyles.form.inputTextColor,
                                  borderRadius: '6px',
                                  padding: '1px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "14px",
                                  backgroundColor: themeStyles.main.mainBg,
                                  color: themeStyles.form.inputTextColor,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? "#167AC3"
                                    : state.isFocused
                                      ? themeStyles.topBar.menuItemsHoverColor
                                      : "transparent",
                                  color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                  fontWeight: 600
                                }),
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={false}
                              isLoading={false}
                              isClearable={false}
                              isRtl={false}
                              isSearchable={false}
                              name="vehicleMake"
                              value={vehicleMakeOptions.find(
                                (item) => item.value === vehicleMarkeId
                              )}
                              onChange={(vehicleMake: any) =>
                                setVehicleMarkeId(vehicleMake ? vehicleMake.value : "")
                              }
                              options={vehicleMakeOptions}
                              required
                            />

                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Model</label>
                            <Select
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  backgroundColor: "transparent",
                                  color: themeStyles.form.inputTextColor,
                                  borderRadius: '6px',
                                  padding: '1px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "14px",
                                  backgroundColor: themeStyles.main.mainBg,
                                  color: themeStyles.form.inputTextColor,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? "#167AC3"
                                    : state.isFocused
                                      ? themeStyles.topBar.menuItemsHoverColor
                                      : "transparent",
                                  color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                  fontWeight: 600
                                }),
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={false}
                              isLoading={false}
                              isClearable={false}
                              isRtl={false}
                              isSearchable={false}
                              name="vehicleModel"
                              value={vehicleModel}
                              onChange={(value: any) => setVehicleModel(value)}
                              options={availableVehicleModeOptions}

                            />
                          </div>
                        </div>

                      </div>

                      <div className="grid grid-cols-2 gap-6 mt-[16px]">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Engine</label>
                            <Select
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  backgroundColor: "transparent",
                                  color: themeStyles.form.inputTextColor,
                                  borderRadius: '6px',
                                  padding: '1px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "14px",
                                  backgroundColor: themeStyles.main.mainBg,
                                  color: themeStyles.form.inputTextColor,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? "#167AC3"
                                    : state.isFocused
                                      ? themeStyles.topBar.menuItemsHoverColor
                                      : "transparent",
                                  color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                  fontWeight: 600
                                }),
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={false}
                              isLoading={false}
                              isClearable={false}
                              isRtl={false}
                              isSearchable={false}
                              name="vehicleMake"
                              value={vehicleEngine}
                              onChange={(value: any) => setVehicleEngine(value)}
                              options={availableVehicleEngineOptions}
                              required
                            />

                          </div>
                        </div>
                        <div className="space-y-4">

                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-6 mt-[16px]">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Class</label>
                            <Select
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  backgroundColor: "transparent",
                                  color: themeStyles.form.inputTextColor,
                                  borderRadius: '6px',
                                  padding: '1px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "14px",
                                  backgroundColor: themeStyles.main.mainBg,
                                  color: themeStyles.form.inputTextColor,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? "#167AC3"
                                    : state.isFocused
                                      ? themeStyles.topBar.menuItemsHoverColor
                                      : "transparent",
                                  color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                  fontWeight: 600
                                }),
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={false}
                              isLoading={false}
                              isClearable={false}
                              isRtl={false}
                              isSearchable={false}
                              name="vehicleClass"
                              value={vehicleClassOptions.find(
                                (item) => item.value === vehicleClassId
                              )}
                              onChange={(vehicleClass: any) =>
                                setVehicleClassId(vehicleClass ? vehicleClass.value : "")
                              }
                              options={vehicleClassOptions}
                              required
                            />

                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Secondary Vehicle Class</label>
                            <Select
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  backgroundColor: "transparent",
                                  color: themeStyles.form.inputTextColor,
                                  borderRadius: '6px',
                                  padding: '1px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "14px",
                                  backgroundColor: themeStyles.main.mainBg,
                                  color: themeStyles.form.inputTextColor,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? "#167AC3"
                                    : state.isFocused
                                      ? themeStyles.topBar.menuItemsHoverColor
                                      : "transparent",
                                  color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                  fontWeight: 600
                                }),
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={false}
                              isLoading={false}
                              isClearable={false}
                              isRtl={false}
                              isSearchable={false}
                              name="vehicleSecondaryClass"
                              value={vehicleClassOptions.find(
                                (item) => item.value === vehiclSecondaryClassId
                              )}
                              onChange={(vehicleClass: any) =>
                                setVehiclSecondaryClassId(
                                  vehicleClass ? vehicleClass.value : ""
                                )
                              }
                              options={vehicleClassOptions}

                            />
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-6 mt-[16px]">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Type</label>
                            <select
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={vehicleTypeId}
                              onChange={(e) => setVehicleTypeId(e.target.value)}
                            >
                              {
                                vehicleTypeOptions.map((item: any) => {
                                  return <option className={`${themeStyles.main.tailwindSectionBg}`} key={item.value} value={item.value}>{item.label}</option>;
                                })
                              }
                            </select>

                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Year</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={vehicleYear}
                              onChange={(e) => setVehicleYear(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-6 mt-[16px]">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Avaliable Date</label>
                            <CustomFormatDatePicker
                              value={availableDate}
                              onChange={setAvailableDate}
                              dateFormat={dateFormat}
                              required={true}
                            />
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Avaliable Until</label>
                            <CustomFormatDatePicker
                              value={availableUntil}
                              onChange={setAvailableUtil}
                              dateFormat={dateFormat}
                              required={true}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-6 mt-[16px]">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Color</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={vehicleColor}
                              onChange={(e) => setColor(e.target.value)}
                              required
                            />

                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Odometer</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={odometer}
                              onChange={(e) => setOdometer(validateMin(e.target.value, 0))}
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-6 mt-[16px]">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Status</label>
                            <select
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={statusId}
                              onChange={(e) => setStatusId(e.target.value)}
                              required
                            >
                              {vehicleStatus.map((item: any) => {
                                return <option className={`${themeStyles.main.tailwindSectionBg}`} key={item.value} value={item.value}>{item.label}</option>;
                              })}
                            </select>

                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Fuel Level</label>
                            <select
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={fuelLevel}
                              onChange={(e) => setFuelLevel(e.target.value)}
                              required
                            >
                              <option className={`${themeStyles.main.tailwindSectionBg}`} value={0}>0</option>
                              <option className={`${themeStyles.main.tailwindSectionBg}`} value={1}>1</option>
                              <option className={`${themeStyles.main.tailwindSectionBg}`} value={2}>2</option>
                              <option className={`${themeStyles.main.tailwindSectionBg}`} value={3}>3</option>
                              <option className={`${themeStyles.main.tailwindSectionBg}`} value={4}>4</option>
                              <option className={`${themeStyles.main.tailwindSectionBg}`} value={5}>5</option>
                              <option className={`${themeStyles.main.tailwindSectionBg}`} value={6}>6</option>
                              <option className={`${themeStyles.main.tailwindSectionBg}`} value={7}>7</option>
                              <option className={`${themeStyles.main.tailwindSectionBg}`} value={8}>8</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-6 mt-[16px]">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Current Location</label>
                            <select
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={currentLocationId}
                              onChange={(e) => setCurrentLocationId(e.target.value)}
                              required
                            >
                              {currentLocations.map((item: any) => {
                                return <option className={`${themeStyles.main.tailwindSectionBg}`} key={item.value} value={item.value}>{item.label}</option>
                              })}
                            </select>

                          </div>
                        </div>

                        <div className="space-y-4">

                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-6 mt-[16px]">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Last Maintenance OdoMeter</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={lastMaintenanceOdoMeter}
                              onChange={(e) =>
                                setLastMaintenanceOdoMeter(validateMin(e.target.value, 0))
                              }
                              required
                            />

                          </div>
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Last Wheel Rotation OdoMeter</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={lastWheelRotationOdoMeter}
                              onChange={(e) =>
                                setLastWheelRotationOdoMeter(validateMin(e.target.value, 0))
                              }
                              required
                            />

                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Last Wheel Alignment OdoMeter</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={lastWheelAlignmentOdoMeter}
                              onChange={(e) =>
                                setLastWheelAlignmentOdoMeter(validateMin(e.target.value, 0))
                              }
                              required
                            />

                          </div>

                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Last Maintenance Date</label>
                            <CustomFormatDatePicker
                              value={lastMaintenanceDate}
                              onChange={setLastMaintenanceDate}
                              dateFormat={dateFormat}
                              required={true}
                            />

                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}> Last Wheel Rotation Date</label>
                            <CustomFormatDatePicker
                              value={lastWheelRotationDate}
                              onChange={setLastWheelRotationDate}
                              dateFormat={dateFormat}
                              required={true}
                            />

                          </div>
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}> Last Wheel Alignment Date</label>
                            <CustomFormatDatePicker
                              value={lastWheelAlignmentDate}
                              onChange={setLastWheelAlignmentDate}
                              dateFormat={dateFormat}
                              required={true}
                            />

                          </div>
                        </div>
                      </div>
                      <div className="flex gap-4 mt-6">
                        <Button variant="contained"
                          sx={{
                            backgroundColor: colorConfigs.btn.main.bg
                          }}
                          type="submit">
                          Save
                        </Button>

                        <Button variant="contained"
                          sx={{
                            backgroundColor: colorConfigs.btn.cancel.bg,
                            border: colorConfigs.btn.cancel.border,
                            color: colorConfigs.btn.cancel.color
                          }}
                          onClick={() => navigate(-1)}>
                          Cancel
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="mt-2 p-2 w-[50%]">
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}